var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.45 5.58179C10.45 8.11196 5.72498 15.2545 5.72498 15.2545C5.72498 15.2545 1 8.11196 1 5.58179C1 3.05163 3.11574 1 5.72498 1C8.33421 1 10.45 3.05163 10.45 5.58179Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72502 6.59982C6.59486 6.59982 7.30001 5.91604 7.30001 5.07255C7.30001 4.22907 6.59486 3.54529 5.72502 3.54529C4.85517 3.54529 4.15002 4.22907 4.15002 5.07255C4.15002 5.91604 4.85517 6.59982 5.72502 6.59982Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.718fda84fe9fa0273c46febda9f7fa59.svg";
export { ForwardRef as ReactComponent };